module.exports = __webpack_public_path__ + "static/media/4전쟁-박꽃이 피었습니다.0dbd8eca.mp3";